// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/UST.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/ust-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;
  padding: 0;
}

@media (min-width: 1024px) {
  .login-container {
    flex-direction: row;
  }
}

.left-section {
  flex: 1;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat;
  display: none; /* Hide on mobile */
  margin-bottom: 55px;
}

@media (min-width: 1024px) {
  .left-section {
    display: block; /* Show on large screens */
  }
}

.right-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(247, 244, 244);
  width: 100%;
  padding: 20px;
}

@media (max-width: 768px) {
  .right-section {
    padding: 10px;
  }
}
.login-title{
  color: #014D4E;
}
.login-card {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.ust-logo {
  width: 80px;
  height: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/cover no-repeat;
}

.login-image {
  height: 78px;
  width: 105px;
}

/* ✅ Updated Button Color */
.custom-button {
  background-color: #1f415b !important;
  border: none;
}

.custom-button:hover {
  background-color: #1677ff !important;
}

/* ✅ Forgot Password Link Color */
.forgot-password {
  color: #1f415b !important;
  text-decoration: none;
}

.forgot-password:hover {
  text-decoration: underline;
}

/* ✅ Custom Checkbox Color */
.custom-checkbox .ant-checkbox-inner {
  border-color: #1f415b !important;
}

.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #1f415b !important;
  border-color: #1f415b !important;
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/components/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,OAAO;EACP,0EAA6D;EAC7D,aAAa,EAAE,mBAAmB;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc,EAAE,0BAA0B;EAC5C;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0EAAkE;AACpE;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC","sourcesContent":[".login-container {\n  display: flex;\n  height: 100vh;\n  flex-direction: column;\n  justify-content: space-between;\n  max-width: 100%;\n  padding: 0;\n}\n\n@media (min-width: 1024px) {\n  .login-container {\n    flex-direction: row;\n  }\n}\n\n.left-section {\n  flex: 1;\n  background: url(\"/src/assets/UST.jpg\") center/cover no-repeat;\n  display: none; /* Hide on mobile */\n  margin-bottom: 55px;\n}\n\n@media (min-width: 1024px) {\n  .left-section {\n    display: block; /* Show on large screens */\n  }\n}\n\n.right-section {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgb(247, 244, 244);\n  width: 100%;\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .right-section {\n    padding: 10px;\n  }\n}\n.login-title{\n  color: #014D4E;\n}\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n  background: rgb(255, 255, 255);\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.ust-logo {\n  width: 80px;\n  height: auto;\n  background: url(\"/src/assets/ust-logo.png\") center/cover no-repeat;\n}\n\n.login-image {\n  height: 78px;\n  width: 105px;\n}\n\n/* ✅ Updated Button Color */\n.custom-button {\n  background-color: #1f415b !important;\n  border: none;\n}\n\n.custom-button:hover {\n  background-color: #1677ff !important;\n}\n\n/* ✅ Forgot Password Link Color */\n.forgot-password {\n  color: #1f415b !important;\n  text-decoration: none;\n}\n\n.forgot-password:hover {\n  text-decoration: underline;\n}\n\n/* ✅ Custom Checkbox Color */\n.custom-checkbox .ant-checkbox-inner {\n  border-color: #1f415b !important;\n}\n\n.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #1f415b !important;\n  border-color: #1f415b !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
